import { TextField } from 'react-admin'

const TextModelFields = (isSmallBusiness: boolean) => {

  const fields = [
    <TextField whiteSpace={'pre-line'} source="textModel.introduction" label="resources.textTemplates.introduction" emptyText="-" />,
    <TextField whiteSpace={'pre-line'} source="textModel.terms" label="resources.textTemplates.terms" emptyText="-" />,
    <TextField whiteSpace={'pre-line'} source="textModel.ending" label="resources.textTemplates.ending" emptyText="-" />,
    <TextField whiteSpace={'pre-line'} source="textModel.deliveryDateNotice" label="resources.textTemplates.deliveryDateNotice" emptyText="-" />
  ]

  const fieldsSmallBusiness = [
    ...fields,
    <TextField whiteSpace={'pre-line'} source="textModel.isSmallBusinessNotice" label="resources.textTemplates.isSmallBusinessNotice" emptyText="-" />,
  ]

  const fieldsNoSmallBusiness = [
    ...fields,
    <TextField whiteSpace={'pre-line'} source="textModel.reverseChargeNotice" label="resources.textTemplates.reverseChargeNotice" emptyText="-" />,
  ]

  return (
      isSmallBusiness ? fieldsSmallBusiness : fieldsNoSmallBusiness
  )
}

export default TextModelFields